module.exports = require("core-js/library/fn/object/define-property");


//////////////////
// WEBPACK FOOTER
// ../node_modules/@babel/runtime/core-js/object/define-property.js
// module id = 14
// module chunks = 0 1 2 4